import { css } from 'styled-components';

import { Colour } from '@xemplo/style-constants';

export const fieldVariables = css`
  --input-width: 100%;
  --input-height: 48px;
  --input-bg-color: ${Colour.Light[100]};
  --input-border-color: ${Colour.Gray[200]};
  --input-border-radius: 8px;
  --input-text-color: ${Colour.Gray[800]};
  --input-label-optional-text-color: ${Colour.Gray[500]};
  --input-label-text-color: ${Colour.Gray[500]};
  --input-placeholder-text-color: ${Colour.Gray[400]};
  --input-leading-icon-color: ${Colour.Gray[400]};
  --input-trailing-icon-color: ${Colour.Gray[400]};
`;
